var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"d":"M1 15H13.6M8.7 1L11.5 3.8L3.8 11.5H1V8.70001L8.7 1Z","stroke":"black","stroke-linecap":"round","stroke-linejoin":"round"}})
}
var staticRenderFns = []

export { render, staticRenderFns }